import { CampaignResponse } from '@/api/campaignPlaner/fetchCampaign';
import { getCampaignInternalRules } from '@/dashboards/CampaignOptimization/helpers/getCampaignInternalRules';
import { useCampaignOptimizationUrl } from '@/dashboards/CampaignOptimization/hooks/useCampaignOptimizationUrl';
import { useDashboardGlobalContext } from '@/dashboards/providers/dashboardGlobalContext';
import { useMemo } from 'react';

export const useDisabledChannels = (campaign?: CampaignResponse) => {
    const { disabledChannelsRules } = useDashboardGlobalContext();
    const {
        search: { startDate, endDate },
    } = useCampaignOptimizationUrl();

    return useMemo(() => {
        const fromGlobalRules = disabledChannelsRules.reduce(
            (acc, rule): string[] => {
                if (rule.target === 'campaign') {
                    acc.push(rule.channel);
                }
                return acc;
            },
            [] as string[],
        );

        const campaignInternalRules = getCampaignInternalRules(
            campaign,
            startDate,
            endDate,
        );

        const fromInternalRules = campaignInternalRules.reduce(
            (acc, rule): string[] => {
                if (
                    rule.type === 'Total budget' &&
                    rule.subtype === 'is exactly' &&
                    rule.value == '0'
                ) {
                    acc.push(rule.channel);
                }
                return acc;
            },
            [] as string[],
        );

        return [...fromGlobalRules, ...(fromInternalRules || [])];
    }, [campaign, disabledChannelsRules, endDate, startDate]);
};
